import App from '../App'
import Block from './Block'
import Image from '../util/Image'
import { TweenMax, TimelineMax, Expo, Power1 } from 'gsap'
import { throttle } from 'throttle-debounce'

export default class TrailEffect extends Block {
  setDefaultVariables() {
    this.MathUtils = {
      lerp: (a, b, n) => (1 - n) * a + n * b,
      distance: (x1, y1, x2, y2) => Math.hypot(x2 - x1, y2 - y1)
    }
    this.mousePos = {
      x: 0,
      y: 0
    }
    this.lastMousePos = this.mousePos
    this.cacheMousePos = this.mousePos
  }

  bindMethods() {
    super.bindMethods()

    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseMoveThrottle = throttle(50, this.onMouseMove)
  }

  getElems() {
    super.getElems()
    
    this.DOMImages = this.el.querySelectorAll('img')
  }

  onEnterCompleted() {

    setTimeout(() => {
      this.createImages()
    }, 500)
  }

  createImages() {
    this.images = []

    for (let i = 0; i < this.DOMImages.length; i++) {
      this.images.push(new Image(this.DOMImages[i]))
    }

    this.imagesTotal = this.images.length
    this.imgPosition = 0
    this.zIndexVal = 1
    this.threshold = 45
  }

  events() {
    this.el.addEventListener('mousemove', this.onMouseMoveThrottle, { passive: true })
    this.el.addEventListener('touchmove', this.onMouseMoveThrottle, { passive: true })
  }

  init() {
    super.init()

    this.setDefaultVariables()
  }

  getMouseDistance() {
    return this.MathUtils.distance(this.mousePos.x, this.mousePos.y, this.lastMousePos.x, this.lastMousePos.y)
  }

  onMouseMove(e) {
    this.mousePos = this.getMousePos(e)
  }

  getMousePos(ev) {
    let posx = 0
    let posy = 0

    if (ev.pageX || ev.pageY) {
        posx = ev.pageX
        posy = ev.pageY
    } else if (ev.clientX || ev.clientY) 	{
        posx = ev.clientX + body.scrollLeft + docEl.scrollLeft
        posy = ev.clientY + body.scrollTop + docEl.scrollTop
    }

    return {
      x: posx,
      y: posy + App.currentScroll
    }
  }

  update() {
    if (App.isMobile || !this.el.classList.contains('is-inview') || !this.images) return

    const distance = this.getMouseDistance()

    this.cacheMousePos.x = this.MathUtils.lerp(this.cacheMousePos.x || this.mousePos.x, this.mousePos.x, 0.1)
    this.cacheMousePos.y = this.MathUtils.lerp(this.cacheMousePos.y || this.mousePos.y, this.mousePos.y, 0.1)

    if (distance > this.threshold) {
        this.showNextImage()

        ++this.zIndexVal
        this.imgPosition = this.imgPosition < this.imagesTotal - 1 ? this.imgPosition + 1 : 0
        
        this.lastMousePos = this.mousePos
    }

    let isIdle = true

    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].isActive()) {
        isIdle = false
        break;
      }
    }

    if (isIdle && this.zIndexVal !== 1) {
        this.zIndexVal = 1
    }
  }

  showNextImage() {
    if (!this.images) return

    const img = this.images[this.imgPosition]

    TweenMax.killTweensOf(img.DOM)

    new TimelineMax()
    .set(img.DOM, {
      startAt: {
        opacity: 0,
        scale: 0
      },
      opacity: 1,
      scale: 0.8,
      zIndex: this.zIndexVal,
      x: this.cacheMousePos.x - img.rect.width / 2,
      y: this.cacheMousePos.y - img.rect.height / 2
    }, 0)
    .to(img.DOM, 0.6, {
      scale: 1,
      ease: Expo.easeOut
    }, 0)
    .to(img.DOM, 1, {
        ease: Expo.easeOut,
        x: this.mousePos.x - img.rect.width / 2,
        y: this.mousePos.y - img.rect.height / 2
    }, 0)
    .to(img.DOM, 1, {
        ease: Power1.easeOut,
        opacity: 0
    }, 0.4)
    // .to(img.DOM, 1, {
    //     ease: Quint.easeOut,
    //     scale: 0.8
    // }, 0.4)
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/TrailEffect.js